import React from 'react';
import ListingForm from '../components/admin/ListingForm';

const AdminCreateListing = () => {
  return (
    <div className="px-[1.25rem] py-[1.25rem]">
      <div className="rounded-[18px] border border-[#262626] bg-[#111] p-[1.25rem]">
        <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-[#EEC24B]">Create page</p>
        <h2 className="mt-[0.35rem] text-[28px] font-bold text-white">Create listing</h2>
        <p className="mt-[0.35rem] max-w-[760px] text-[15px] text-[#BDBDBD]">
          Use this dedicated page to build a new rent or property listing without opening a popup.
        </p>
      </div>

      <div className="mt-[1.25rem]">
        <ListingForm initialType="rent" />
      </div>
    </div>
  );
};

export default AdminCreateListing;
